module.exports = __webpack_public_path__ + "img/27_15.2eb842e1.png";